import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Ordreoplysninger',
  sections: {
    driver_info: 'Chaufførinfo',
    order_info: 'Ordreoplysninger',
    price_info: 'Prisoplysninger',
    adjustments: 'Justeringer',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Afhentning',
    [OrderMethod.Delivery]: 'Levering',
    [OnSiteLocationType.RoomService]: 'Roomservice',
    [OnSiteLocationType.TableService]: 'Bordservice',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Værelsesnummer',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Bordnummer',
    },
  },
  labels: {
    wolt_support: 'Wolts supporttelefonnummer: {{phone_number}}',
    wolt_support_text:
      'Hvis du har spørgsmål om ordren, chaufføren eller problemer, så ring til Wolt. Det er vigtigt at sige, at det er en <strong>Wolt Drive</strong>-ordre',
    dummy_order: 'Testordre',
    asap: 'Hurtigst muligt',
    driver_name: 'Chaufførens navn',
    driver_phone_number: 'Chaufførens telefon',
    pin_code: 'PIN',
    dropoff_pin_code: 'Leverings-PIN',
    original: 'Original',
    delivery_fee: 'Leveringsgebyr',
    tip: 'Drikkepenge',
    service_fee: 'Onlinebehandling',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal-gebyr',
    },
    promo_applied: {
      default: 'Kampagnekode anvendt',
      [CouponType.Reward]: 'Loyalitetspoint anvendt',
      [CouponType.Cashback]: 'Loyalitetspoint anvendt',
      [CouponType.PromoCode]: 'Kampagnekode anvendt',
      [CouponType.GiftCard]: 'Gavekort anvendt',
    },
    tax: 'Moms',
    total: 'I alt',
    online_payment: 'Kunden har allerede betalt i {{provider}}-appen',
    cash_payment: 'Betaling på stedet',
    invoice_payment: 'Betaling via faktura',
    old_order: 'Denne ordre er gennemført',
    pickup_time: 'Afhentningstid',
    pickup_asap: 'Kunden har bedt om hurtigst mulig afhentning.',
    points_used: 'Denne ordre indeholder en belønning med loyalitetspoint indløst af en loyal kunde',
    order_instructions: 'Ordreinstruktioner:',
    today: 'i dag',
  },
  schedule: {
    header: 'Planlagt til {{date}}, {{time}}',
    text: 'Vi minder dig om, når det er tid til at begynde at tilberede ordren',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Ønsket af kunden',
    [RefundReason.Reclamation]: 'Reklamation',
    [RefundReason.CommunicationError]: 'Kommunikationsfejl',
    [RefundReason.Other]: 'Andet',
    [RefundReason.Dispute]: 'Kundetvist',
    dispute_win: 'Vundet kundetvist',
    null: '',
  },
  toasts: {
    print_one: 'Udskriver {{count}} kvittering: Ordre <strong>#{{orderNumber}}</strong>...',
    print_other: 'Udskriver {{count}} kvitteringer: Ordre <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Refundering gennemført: Ordre <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Udskriv',
    confirm: 'Bekræft',
    reject: 'Afvis',
    refund: 'Refunder',
  },
};
